"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractFile = void 0;
var utils_1 = require("../../utils");
var qs = require("qs");
exports.contractFile = function (axios) {
    return {
        getContractfilesMalls: function (request) {
            return axios.get('/contract-files/mall', request);
        },
        putContractfilesMalls: function (request) {
            if (!request.headers) {
                return axios.put('/contract-files/mall', request.data);
            }
            var config = {
                headers: __assign({}, request.headers),
            };
            return axios.put('/contract-files/mall', request.data, config);
        },
        getContractFilesTemp: function (request) {
            return axios.get('/contract-files/temp', request);
        },
        putContractFilesTempTempCode: function (request) {
            var url = utils_1.paramPathchange('/contract-files/temp/{tempCode}', request);
            if (!request.headers) {
                return axios.put(url, request.data);
            }
            var config = {
                headers: __assign({}, request.headers),
            };
            return axios.put(url, request.data, config);
        },
        deleteContractFilesTemp: function (request) {
            return axios.delete('/contract-files/temp', request);
        },
        getContractFilesContractHistories: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/contract-files/contract/histories?" + query);
        },
    };
};
